import { FC } from 'react';
import strings from '../../../../common/Translation/Translate';
import { URLS } from '../../../../utils/constants/urls';
import IdsMappingList, { IdsMappingListConfig } from '../shared/IdsMappingList';
import { formatIdsBookingStatus, optionLabel, optionValue } from '../shared/idsMappingTableCells';
import { AddEditStatusMappingsForm, STATUS_MAPPING_OPTIONS } from './AddEditStatusMappings/AddEditStatusMappingsForm';

const statusMappingConfig: IdsMappingListConfig = {
  kind: 'status',
  title: 'Status Mappings',
  subtitle: 'Map BBR booking statuses to IDS reservation statuses.',
  addButtonText: 'Add Status Mapping',
  addDrawerTitle: 'Add Status Mapping',
  editDrawerTitle: 'Edit Status Mapping',
  searchPlaceholder: 'Search by IDS name or code',
  entityLabel: 'Status mappings',
  listApi: URLS.statusMappings,
  addApi: URLS.addStatusMapping,
  getById: URLS.getStatusMappingById,
  saveApi: URLS.editStatusMapping,
  deleteApi: URLS.deleteStatusMapping,
  importApi: URLS.importStatusMappings,
  downloadImportTemplate: URLS.downloadStatusMappingsTemplate,
  bbrHeader: 'BBR Status',
  idsHeader: 'IDS Status',
  idsSortField: 'reservationStatusName',
  getBbrLabel: row => formatIdsBookingStatus(optionLabel(row.status)),
  getIdsName: row => row.reservationStatusName,
  getIdsCode: row => row.reservationStatusCode,
  formModel: () => AddEditStatusMappingsForm(strings),
  emptyFormValues: { status: '', statusName: '', statusCode: '' },
  mapResponseToForm: data => {
    const statusValue = optionValue(data.status);
    return {
      status: STATUS_MAPPING_OPTIONS.find(option => option.value === statusValue) || data.status || '',
      statusName: data.reservationStatusName || '',
      statusCode: data.reservationStatusCode || '',
    };
  },
  mapFormToPayload: body => ({
    status: optionValue(body.status),
    reservationStatusName: body.statusName,
    reservationStatusCode: body.statusCode,
  }),
  getDeleteEntityName: values => {
    const status = optionValue(values.status);
    if (status) return formatIdsBookingStatus(String(status));
    return String(values.statusName || '');
  },
};

const StatusMappingsList: FC = () => <IdsMappingList config={statusMappingConfig} />;

export default StatusMappingsList;
